import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { PinCodeConfig } from './pin-code-config';

@Component({
  selector: 'app-pin-code',
  templateUrl: './pin-code.component.html',
  styleUrls: ['./pin-code.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
  ],
})
export class PinCodeComponent implements OnInit, OnChanges {
  @Input() boardPinCode = '';
  pinCodeForm = this.getPinCodeForm();
  @Input() config: PinCodeConfig = { isPinCodeBoard: false };
  @Output() pinCodeEmitter = new EventEmitter<string>();
  applyPinCodeInputClass?: boolean;

  ngOnInit(): void {
    if (this.config.isPinCodeBoard) {
      this.pinCodeForm.controls.pinCode.disable();
    }
  }

  ngOnChanges(): void {
    if (this.config.isPinCodeBoard) {
      this.applyPinCodeInputClass = false;
      this.pinCodeForm = this.getPinCodeForm();
      this.pinCodeForm.controls.pinCode.disable();
      for (let i = 0; i < this.boardPinCode.length; i++) {
        this.pinCodeForm.controls.pinCode.controls[i].patchValue(
          this.boardPinCode.charAt(i),
        );
      }
      if (this.boardPinCode.length === 6) {
        this.pinCodeEmitter.emit(this.boardPinCode);
      }
    }
  }

  processPin(event: KeyboardEvent, id: number): void {
    if (this.config.isPinCodeBoard) {
      this.pinCodeForm = this.getPinCodeForm();
      return;
    }
    const target = event.target as HTMLInputElement;
    const maxLength = 1;
    const lastInput = 5;
    const firstInput = 0;
    if (event.key === 'Backspace' && target.value === '' && id > firstInput) {
      // Si se presiona la tecla de retroceso (Backspace) y el campo está vacío, moverse al input anterior
      const prevInputId = id - 1;
      const prevInput = document.getElementById(
        prevInputId.toString(),
      ) as HTMLInputElement;
      prevInput.focus();
    } else if (
      event.key !== 'Backspace' &&
      target.value.length >= maxLength &&
      id < lastInput
    ) {
      // Si se presiona una tecla que no sea de retroceso (Backspace) y se alcanza la longitud máxima, moverse al siguiente input
      const nextInputId = id + 1;
      const nextInput = document.getElementById(
        nextInputId.toString(),
      ) as HTMLInputElement;
      nextInput.focus();
    }
    this.applyPinCodeInputClass = true;
  }

  verifyPin() {
    if (this.config.isPinCodeBoard) {
      this.pinCodeForm = this.getPinCodeForm();
      return;
    }
    const pinCode = this.pinCodeForm.get('pinCode')?.value.join('').trim();
    if (pinCode) {
      this.pinCodeEmitter.emit(pinCode);
    } else {
      this.pinCodeEmitter.emit(undefined);
    }
  }

  changeBackgroud(i: number): string {
    if (this.config.isPinCodeBoard) {
      const form = document.getElementsByClassName('pin-code-input');
      const div = form
        .item(i)
        ?.getElementsByClassName('mdc-text-field--outlined');
      if (i < this.boardPinCode.length) {
        div?.item(0)?.classList.add('blue-pin-code');
        div?.item(0)?.classList.remove('disabled-pin-code');
      } else {
        div?.item(0)?.classList.remove('blue-pin-code');
        div?.item(0)?.classList.add('disabled-pin-code');
      }
    }
    return '';
  }

  resetComponent() {
    this.pinCodeForm = this.getPinCodeForm();
    this.boardPinCode = '';
  }

  private getPinCodeForm() {
    return new FormGroup({
      pinCode: new FormArray(
        [
          new FormControl('', Validators.maxLength(1)),
          new FormControl('', Validators.maxLength(1)),
          new FormControl('', Validators.maxLength(1)),
          new FormControl('', Validators.maxLength(1)),
          new FormControl('', Validators.maxLength(1)),
          new FormControl('', Validators.maxLength(1)),
        ],
        this.validatePinCodeArray,
      ),
    });
  }

  private validatePinCodeArray(
    control: AbstractControl,
  ): { [key: string]: boolean } | null {
    if (control instanceof FormArray) {
      const isEmpty = control.controls.every(c => {
        const value = c.value;
        return typeof value === 'string' ?
               value.trim() === '' : 
               !value;
      });
      return isEmpty ? { emptyPinCodeArray: true } : null;
    }
    return null;
  }
}
